import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl, getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import LinksState from "@insite/client-framework/Store/Links/LinksState";
import translate from "@insite/client-framework/Translate";
import VmiPageTypes from "@insite/client-framework/Types/VmiPageTypes";
import Breadcrumbs, { BreadcrumbsPresentationProps } from "@insite/mobius/Breadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LinkProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl: getHomePageUrl(state),
        siteName: state.context.website.name,
    };
};

export interface PageBreadcrumbsStyles {
    breadcrumbs?: BreadcrumbsPresentationProps;
}

export const pageBreadcrumbStyles: PageBreadcrumbsStyles = {
    breadcrumbs: {
        css: css`
            margin: 10px 20px 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    null,
                ])}

            a + span {
                position: relative;
                font-size: 0;
                margin: 0 8px;
                margin-bottom: 4px;
                &:after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 2px;
                    display: block;
                    width: 1px;
                    height: 12px;
                    font-size: ${TYPOGRAPHY.size.tiny};
                    border-right: 1px solid ${COLORS.border.light};
                }
            }
            span {
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.tiny};
                line-height: 16px;
                color: ${COLORS.background.tag} !important;
                text-transform: capitalize;
            }
            & > span:last-child {
                color: ${getProp("theme.typography.p.color")} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            text-overflow: initial !important;
                            overflow: initial !important;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 1px;
                    `,
                    null,
                    css`
                        margin: 1px;
                    `,
                    null,
                ])}
        `,
    },
};
export const nisPageBreadcrumbStyles: PageBreadcrumbsStyles = {
    breadcrumbs: {
        css: css`
            margin: 10px 20px 25px;
            &::-webkit-scrollbar {
                display: none !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    css`
                        white-space: nowrap;
                        overflow-x: auto;
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        padding: 10px 0px;
                    `,
                    null,
                ])}

            a + span {
                position: relative;
                font-size: 0;
                margin: 0 8px;
                margin-bottom: 4px;
                &:after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 2px;
                    display: block;
                    width: 1px;
                    height: 12px;
                    font-size: ${TYPOGRAPHY.size.tiny};
                    border-right: 1px solid ${COLORS.border.light};
                }
            }
            span {
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.tiny};
                line-height: 16px;
                color: ${COLORS.background.tag} !important;
                text-transform: capitalize;
            }
            & > span:last-child {
                color: ${getProp("theme.typography.p.color")} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            text-overflow: initial !important;
                            overflow: initial !important;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 1px;
                    `,
                    null,
                    css`
                        margin: 1px;
                    `,
                    null,
                ])}
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps>;

const PageBreadcrumbs = (props: Props) => {
    const links = props.links || generateLinksFrom(props.linksState, props.nodeId, props.homePageUrl);
    const styles = props.siteName === "Nisco" ? nisPageBreadcrumbStyles : pageBreadcrumbStyles;

    return <Breadcrumbs links={links} data-test-selector="pageBreadcrumbs" {...styles.breadcrumbs} />;
};

export function generateLinksFrom(linksState: LinksState, nodeId: string, homePageUrl: string) {
    const links: LinkProps[] = [];
    let currentLink = getPageLinkByNodeId({ links: linksState }, nodeId);

    const vmiExcludePageTypes: string[] = ["HomePage", "MyAccountPage"];
    const search = (targetText: string) => (sourceTextArray: string) => sourceTextArray === targetText;
    const isVmiPageType = !currentLink?.type ? false : VmiPageTypes.some(search(currentLink.type));
    while (currentLink) {
        const isVmiExcludePageType = !currentLink?.type ? false : vmiExcludePageTypes.some(search(currentLink.type));
        if (!isVmiPageType || !isVmiExcludePageType) {
            links.unshift({
                children: currentLink.type === "HomePage" ? translate("Home_Breadcrumb") : currentLink.title,
                href: currentLink.url,
                type: currentLink.type,
            });
        }

        currentLink = currentLink.parentId
            ? getPageLinkByNodeId({ links: linksState }, currentLink.parentId)
            : undefined;
    }

    return links;
}

export default connect(mapStateToProps)(PageBreadcrumbs);
